module.exports = __webpack_public_path__ + "static/media/IMG_20190130_112511524.a967af07.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/IMG_20190130_112511524.jpg
// module id = 43
// module chunks = 0